module.exports = __webpack_public_path__ + "img/gg-7.prt.de67a8b7.jpg";